// src/components/ui/Avatar.jsx
// Avatar com fallback de iniciais coloridas baseado em hash do nome.
// Uso:
//   <Avatar src={user.avatar} nome="Rodrigo Carlos" size={48} />
import React from "react";

const PALETA = [
  ["#FEE2E2", "#991B1B"], // vermelho
  ["#FEF3C7", "#92400E"], // amber
  ["#DCFCE7", "#166534"], // verde
  ["#E0F2FE", "#075985"], // azul claro
  ["#DBEAFE", "#1E40AF"], // azul
  ["#EDE9FE", "#5B21B6"], // roxo
  ["#FCE7F3", "#9D174D"], // pink
  ["#CFFAFE", "#0E7490"], // ciano
  ["#FFEDD5", "#9A3412"], // laranja
  ["#F1F5F9", "#334155"], // cinza
];

function hashNome(s) {
  let h = 0;
  const str = String(s || "");
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

function iniciaisDe(nome) {
  if (!nome) return "?";
  const partes = String(nome).trim().split(/\s+/).filter(Boolean);
  if (!partes.length) return "?";
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
}

export default function Avatar({
  src,
  nome = "",
  size = 40,
  borderColor,
  title,
  onClick,
  style,
  className,
}) {
  const tamanho = Number(size) || 40;
  const fonte = Math.max(11, Math.round(tamanho * 0.4));
  const cursor = onClick ? "pointer" : undefined;
  const titulo = title || nome || undefined;

  const baseStyle = {
    width: tamanho,
    height: tamanho,
    borderRadius: "50%",
    overflow: "hidden",
    flexShrink: 0,
    border: borderColor ? `2px solid ${borderColor}` : "2px solid #E2E8F0",
    cursor,
    ...(style || {}),
  };

  if (src) {
    return (
      <img
        src={src}
        alt={nome || "Avatar"}
        title={titulo}
        onClick={onClick}
        className={className}
        style={{ ...baseStyle, objectFit: "cover" }}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    );
  }

  const idx = hashNome(nome) % PALETA.length;
  const [bg, fg] = PALETA[idx];

  return (
    <div
      title={titulo}
      onClick={onClick}
      className={className}
      style={{
        ...baseStyle,
        background: bg,
        color: fg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: fonte,
        userSelect: "none",
      }}
    >
      {iniciaisDe(nome)}
    </div>
  );
}
